<div class="mainpage">
  <div class="heroe landing-section">
    <div class="info">
      <p class="heroe-title bold">
        {{ "LANDING.MAINPAGE.HEROE.TITLE" | translate }}
      </p>
      <p class="heroe-subtitle">
        {{ "LANDING.MAINPAGE.HEROE.SUBTITLE" | translate }}
      </p>
      <app-demo-form></app-demo-form>
    </div>
    <div class="image" ngClass="{{country}}">
      <img [src]="mainHeroeURL" alt="main heroe" />
    </div>
  </div>
  <div class="coverage landing-section">
    <div class="brands">
      <img src="assets/landing/images/main-brands.png" />
    </div>
    <div class="info-countries">
      <p class="info">
        {{ "LANDING.MAINPAGE.COVERAGE.INFO_1" | translate }}
        <span class="semi-bold">{{ "LANDING.MAINPAGE.COVERAGE.INFO_2" | translate }}</span>
        {{ "LANDING.MAINPAGE.COVERAGE.INFO_3" | translate }}
        <span class="semi-bold"> </span>
      </p>
      <div class="countries">
        <img src="assets/landing/images/main-countries.png" alt="countries" />
      </div>
    </div>
  </div>
  <div class="carousel landing-section" *ngIf="selectedCarousel$ | async as carouselItem">
    <p class="section-title">
      {{ "LANDING.MAINPAGE.CAROUSEL.TITLE_1" | translate
      }}<span class="semi-bold">{{ "LANDING.MAINPAGE.CAROUSEL.TITLE_2" | translate }}</span>
    </p>
    <div class="carousel-container">
      <div class="image">
        <img [src]="carouselItem.image" [alt]="carouselItem.title" />
      </div>
      <div class="info">
        <p class="carousel-title semi-bold">
          {{ carouselItem.title | translate }}
        </p>
        <p class="carousel-subtitle">
          {{ carouselItem.subtitle | translate }}
        </p>
      </div>
      <div class="arrow-button left">
        <button class="semi-bold" (click)="changeSelectedCarousel(carouselItem.index, -1)">{{ "\<" }}</button>
      </div>
      <div class="arrow-button right">
        <button class="semi-bold" (click)="changeSelectedCarousel(carouselItem.index, 1)">{{ ">" }}</button>
      </div>
    </div>
    <div class="carousel-cta">
      <button (click)="clickCta()" class="landing-button primary outlined">
        {{ "LANDING.MAINPAGE.CAROUSEL.CTA" | translate }}
      </button>
    </div>
  </div>
  <div class="categories mobile-wide landing-section">
    <p class="section-title">{{'LANDING.MAINPAGE.CATEGORIES.TITLE' | translate}}</p>
    <div class="cats">
      <div class="cat">
        <img class="cat-img" src="assets/landing/images/main-restaurants.png" alt="category 1" />
        <p class="cat-title semi-bold">
          {{ "LANDING.MAINPAGE.CATEGORIES.CAT_1" | translate }}
        </p>
      </div>
      <div class="cat">
        <img class="cat-img" src="assets/landing/images/main-cpgs.png" alt="category 1" />
        <p class="cat-title semi-bold">
          {{ "LANDING.MAINPAGE.CATEGORIES.CAT_2" | translate }}
        </p>
      </div>
      <div class="cat">
        <img class="cat-img" src="assets/landing/images/main-pharmacy.png" alt="category 1" />
        <p class="cat-title semi-bold">
          {{ "LANDING.MAINPAGE.CATEGORIES.CAT_3" | translate }}
        </p>
      </div>
      <div class="cat">
        <img class="cat-img" src="assets/landing/images/main-ecommerce.png" alt="category 1" />
        <p class="cat-title semi-bold">
          {{ "LANDING.MAINPAGE.CATEGORIES.CAT_4" | translate }}
        </p>
      </div>
      <div class="cat">
        <img class="cat-img" src="assets/landing/images/main-spirits.png" alt="category 1" />
        <p class="cat-title semi-bold">
          {{ "LANDING.MAINPAGE.CATEGORIES.CAT_5" | translate }}
        </p>
      </div>
    </div>
  </div>
  <div class="benefits-list">
    <div class="header">
      <p class="section-title semi-bold">
        {{ "LANDING.BENEFITS.TITLE_1" | translate }}
        <span class="semi-bold">{{ "LANDING.BENEFITS.TITLE_2" | translate }}</span>
        {{ "\n" }}
      </p>
      <p class="section-subtitle">
        {{ "LANDING.BENEFITS.SUBTITLE" | translate }}
      </p>
    </div>
    <div class="list-container">
      <div class="benefit b1">
        <div class="benefit-info">
          <p class="benefit-title bold">{{ "LANDING.BENEFITS.B1_TITLE" | translate }}</p>
          <p class="benefit-subtitle">{{ "LANDING.BENEFITS.B1_SUBTITLE" | translate }}</p>
        </div>
        <div class="img-container">
          <img class="benefit-img" src="assets/landing/images/benefits-1.png" />
          <div class="benefit-list">
            <div *ngFor="let benefit of benefits['visibility']" class="benefit-item">
              <img [src]="benefit.icon" height="18px" [alt]="benefit.label"/>
              <p class="benefit-item-label">{{benefit.label | translate}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="benefit b2">
        <div class="benefit-info">
          <p class="benefit-title bold">{{ "LANDING.BENEFITS.B2_TITLE" | translate }}</p>
          <p class="benefit-subtitle">{{ "LANDING.BENEFITS.B2_SUBTITLE" | translate }}</p>
        </div>
        <div class="img-container">
          <img class="benefit-img" src="assets/landing/images/benefits-4.png" />
          <div class="benefit-list">
            <div *ngFor="let benefit of benefits['special']" class="benefit-item">
              <img [src]="benefit.icon" height="18px" [alt]="benefit.label"/>
              <p class="benefit-item-label">{{benefit.label | translate}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="benefit b3">
        <div class="benefit-info">
          <p class="benefit-title bold">{{ "LANDING.BENEFITS.B3_TITLE" | translate }}</p>
          <p class="benefit-subtitle">{{ "LANDING.BENEFITS.B3_SUBTITLE" | translate }}</p>
        </div>
        <div class="img-container">
          <img class="benefit-img" src="assets/landing/images/benefits-3.png" />
          <div class="benefit-list">
            <div *ngFor="let benefit of benefits['security']" class="benefit-item">
              <img [src]="benefit.icon" height="18px" [alt]="benefit.label"/>
              <p class="benefit-item-label">{{benefit.label | translate}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="benefit b4">
        <div class="benefit-info">
          <p class="benefit-title bold">{{ "LANDING.BENEFITS.B4_TITLE" | translate }}</p>
          <p class="benefit-subtitle">{{ "LANDING.BENEFITS.B4_SUBTITLE" | translate }}</p>
        </div>
        <div class="img-container">
          <img class="benefit-img" src="assets/landing/images/benefits-2.png" />
          <div class="benefit-list">
            <div *ngFor="let benefit of benefits['others']" class="benefit-item">
              <img [src]="benefit.icon" height="18px" [alt]="benefit.label"/>
              <p class="benefit-item-label">{{benefit.label | translate}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="benefits-heroe landing-section">
    <div class="info">
      <p class="heroe-title bold">{{ "LANDING.BENEFITS.HEROE.TITLE" | translate }}</p>
      <p class="heroe-subtitle">{{ "LANDING.BENEFITS.HEROE.SUBTITLE" | translate }}</p>
      <button (click)="clickCta()" class="landing-button primary outlined">{{ "LANDING.BENEFITS.HEROE.CTA" | translate }}</button>
    </div>
    <div class="image">
      <img src="assets/landing/images/benefits-heroe.png" alt="main heroe" />
    </div>
  </div>
  <div class="methods">
    <div class="landing-section">
      <p class="methods-title heroe-title semi-bold">
        {{'LANDING.MAINPAGE.METHODS.TITLE' | translate}}
      </p>
    </div>
    <div class="method-cards-container">
      <div class="method-card">
        <p class="method-title semi-bold">{{'LANDING.MAINPAGE.METHODS.MANUAL.TITLE' | translate}}</p>
        <p class="method-description">{{'LANDING.MAINPAGE.METHODS.MANUAL.DESCRIPTION' | translate}}
        </p>
        <img src="assets/landing/images/method-manual.png" alt="manual orders"/>
        <p class="method-disclaimer semi-bofld">{{'LANDING.MAINPAGE.METHODS.MANUAL.DISCLAIMER' | translate}}
        </p>
      </div>
      <div class="method-card">
        <p class="method-title semi-bold">{{'LANDING.MAINPAGE.METHODS.API.TITLE' | translate}}</p>
        <p class="method-description">{{'LANDING.MAINPAGE.METHODS.API.DESCRIPTION' | translate}} </p>
        <img src="assets/landing/images/method-api.png" alt="api orders"/>
        <p class="method-disclaimer semi-bolfd">{{'LANDING.MAINPAGE.METHODS.API.DISCLAIMER' | translate}}</p>
      </div>
      <div class="method-card">
        <p class="method-title semi-bold">{{'LANDING.MAINPAGE.METHODS.RAPPIALIADOS.TITLE' | translate}}</p>
        <p class="method-description">{{'LANDING.MAINPAGE.METHODS.RAPPIALIADOS.DESCRIPTION' | translate}}</p>
        <img src="assets/landing/images/method-rappialiados.png" alt="rappi aliados orders"/>
        <p class="method-disclaimer semi-bolfd">{{'LANDING.MAINPAGE.METHODS.RAPPIALIADOS.DISCLAIMER' | translate}}</p>
      </div>
    </div>
  </div>
</div>
